import { useCanvasLoop } from "@/components/canvasLoop";

const BG = "#F7F4EF";
const rand = (a, b) => { const s = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return s - Math.floor(s); };

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.roundRect ? ctx.roundRect(x, y, w, h, r) : ctx.rect(x, y, w, h);
  ctx.fill();
};

const drawLine = (ctx, L, y, x1, x2, t) => {
  let x = x1 + (rand(L, 0) < 0.15 ? 40 : 0);
  const end = x2 - rand(L, 1) * (x2 - x1) * 0.35;
  for (let k = 0; x < end; k++) {
    const ww = 14 + rand(L, k + 2) * 70;
    if (x + ww > end) break;
    const r = rand(L * 3.1, k * 1.7);
    if (r < 0.1) {
      const p = Math.max(0, Math.min(1, Math.sin(t * 0.55 + rand(L, k) * 12) * 1.6 + 0.4));
      ctx.fillStyle = "rgba(107,96,85,0.16)";
      roundRect(ctx, x, y - 3, ww, 6, 3);
      ctx.fillStyle = "rgba(44,38,33,0.88)";
      if (p > 0.01) roundRect(ctx, x - 2, y - 8, (ww + 4) * p, 16, 1);
    } else if (r < 0.14) {
      ctx.fillStyle = "rgba(158,74,43,0.55)";
      roundRect(ctx, x, y - 3, ww, 6, 3);
    } else {
      ctx.fillStyle = "rgba(107,96,85,0.2)";
      roundRect(ctx, x, y - 3, ww, 6, 3);
    }
    x += ww + 10;
  }
};

const drawFrame = (ctx, w, h, t) => {
  ctx.fillStyle = BG;
  ctx.fillRect(0, 0, w, h);
  const mobile = w < 640;
  const gap = 30;
  const x1 = mobile ? 24 : w * 0.42;
  const x2 = mobile ? w - 24 : w * 0.94;
  const scroll = t * 9;
  const first = Math.floor(scroll / gap);
  const offset = scroll % gap;
  const rows = Math.ceil(h / gap) + 2;
  for (let i = 0; i < rows; i++) {
    const L = first + i;
    const y = i * gap - offset + gap * 0.5;
    if (rand(L, 99) < 0.12) continue;
    drawLine(ctx, L, y, x1, x2, t);
  }
};

export const RedactedCanvas = () => {
  const ref = useCanvasLoop(drawFrame);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" data-testid="hero-redacted-canvas" />;
};
